import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { PasswordInputComponent } from '../../../../shared/ui/password-input';
import { ChangePasswordStore } from '../store/change-password.store';
import { ChangePasswordComponent } from '../components/change-password.component';
import { MatDialogRef } from '@angular/material/dialog';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translationPipe';

@Component({
  selector: 'app-confirm-password',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatInputModule,
    PasswordInputComponent,
    TranslatePipe,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-password-input
      [form]="store.passwordForm"
      controlName="newPassword"
      [labelText]="'New password'"
      [strengthCheck]="true"
    />
    <div class="space"></div>
    <app-password-input
      [form]="store.passwordForm"
      controlName="confirmNewPassword"
      [labelText]="('confirmPassword' | translate | async) ?? ''"
    />
    <div class="text-block">
      {{ 'passwordFollowCriteria' | translate | async }}
      <ul class="text-list">
        <li>{{ 'passwordMinCharacters' | translate | async }}</li>
        <li>{{ 'passwordIncludeCriteria' | translate | async }}</li>
      </ul>
    </div>
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="store.passwordForm.invalid"
      (click)="onSubmitChange()"
      class="confirm-button"
    >
      {{ 'confirm' | translate | async }}
    </button>
  `,
  styles: `
      @use "spacing/spacing-variables" as *;

      .text-block {
        font-size: 14px;
        color: var(--mat-sys-on-surface-variant);
        margin: $spacing-md $spacing-none $spacing-xl;
      }

      .text-list {
        padding-left: $spacing-lg;
      }

      .space {
        height: 12px;
      }
`,
})
export class ConfirmPasswordComponent {
  readonly store = inject(ChangePasswordStore);
  readonly dialogRef = inject(MatDialogRef<ChangePasswordComponent>);

  onSubmitChange(): void {
    this.store.submitPasswordChange(this.dialogRef);
  }
}
